import { Case, CaseListItem } from "../types";
import { apiFetch } from "../utils/api";

const getCases = async (): Promise<CaseListItem[]> => {
  try {
    const response = await apiFetch('/conversation/');

    if (!response.ok) {
      console.error(`Failed to fetch cases: ${response.status} ${response.statusText}`);
      return [];
    }

    return await response.json();

  } catch (error) {
    console.error('Error fetching cases:', error);
    return [];
  }
};

const getCase = async (caseId: string): Promise<Case> => {
  try {
    const response = await apiFetch(`/conversation/${caseId}`);

    if (!response.ok) {
      console.error(`Failed to fetch case: ${response.status} ${response.statusText}`);
      return {} as Case;
    }

    return await response.json();

  } catch (error) {
    console.error('Error fetching case:', error);
    return {} as Case;
  }
};

export { getCases, getCase };
